const adminForm = {
  createUser: [
    {
      type: 'Input',
      label: 'first_name',
      class: 'col-md-3 input-form',
      placeHolder: 'first_name',
      name: 'name',
      id: 'Name',
      style: {},
      required: true
    },
    {
      type: 'Input',
      label: 'last_name',
      placeHolder: 'last_name',
      name: 'Lastname',
      class: 'col-md-3 input-form',
      id: 'LastName',
      style: {},
      required: true
    },

    {
      type: 'Input',
      label: 'email',
      class: 'col-md-3 input-form',
      placeHolder: 'email',
      name: 'Email',
      id: 'Email',
      style: {},
      required: true
    },

    {
      type: 'Select',
      options: 'RoleId',
      label: 'job_role',
      name: 'RoleId',

      class: 'col-md-3 input-form',
      id: 'RoleId',
      selectCatalogName: "Roles",
      style: {},
      required: true
    },
    {
      type: 'Input',
      label: 'job_position',
      class: 'col-md-3 input-form',
      placeHolder: 'job_position',
      name: 'Position',
      id: 'Position',
      style: {},
      required: false
    },
    {
      type: 'Input',
      label: 'phone',
      class: 'col-md-3 input-form',
      placeHolder: 'phone',
      name: 'Telephone',
      id: 'Telephone',
      style: {},
      required: false
    },
    {
      type: 'Input',
      label: 'password',
      class: 'col-md-3 input-form',
      placeHolder: '',
      name: 'Password',
      id: 'Password',
      datatype: 'Password',
      style: {},
      required: true
    },

    {
      type: 'Input',
      label: 'confirm_pass',
      class: 'col-md-3 input-form',
      placeHolder: '',
      name: 'ConfirmPassword',
      id: 'ConfirmPassword',
      datatype: 'Password',
      style: {},
      required: true
    },
    // {
    //   type: 'Transfer',
    //   label: 'Select Office',
    //   class: 'col-md-4 input-form',
    //   placeHolder: '',
    //   name: 'Offices',
    //   id: 'Offices',
    //   datatype: 'array',
    //   catalogRenderName: "label",
    //   catalogName: "Offices",
    //   localeUnit: "Office",
    //   style: {},
    //   iconStyle: { marginLeft: "10px", fontSize: "20px", color: "green" },
    //   required: true
    // },
    // {
    //   type: 'Transfer',
    //   label: 'Select Customer',
    //   class: 'col-md-4 input-form',
    //   placeHolder: '',
    //   name: 'Customers',
    //   id: 'Customers',
    //   catalogRenderName: "label",
    //   catalogName: "Customers",
    //   localeUnit: "Customer",
    //   style: {},
    //   iconStyle: { marginLeft: "10px", fontSize: "20px", color: "green" },
    //   required: true
    // },
    // {
    //   type: 'Transfer',
    //   label: 'Select Country',
    //   class: 'col-md-4 input-form',
    //   placeHolder: '',
    //   name: 'Countries',
    //   id: 'Countries',
    //   catalogRenderName: "label",
    //   catalogName: "Countries",
    //   localeUnit: "Country",
    //   style: {},
    //   iconStyle: { marginLeft: "10px", fontSize: "20px", color: "green" },
    //   required: true
    // },
  ],
  editUser: [
    {
      type: 'Input',
      label: 'name',
      class: 'col-md-3 input-form',
      placeHolder: 'name',
      name: 'name',
      id: 'Name',
      style: {},
      required: true
    },
    {
      type: 'Input',
      label: 'last_name',
      placeHolder: 'last_name',
      name: 'Lastname',
      class: 'col-md-3 input-form',
      id: 'LastName',
      style: {},
      required: true
    },

    {
      type: 'Input',
      label: 'email',
      class: 'col-md-3 input-form',
      placeHolder: 'email',
      name: 'Email',
      id: 'Email',
      style: {},
      required: true
    },

    {
      type: 'Select',
      options: 'RoleId',
      label: 'job_role',
      name: 'RoleId',

      class: 'col-md-3 input-form',
      id: 'RoleId',
      selectCatalogName: "Roles",
      style: {},
      required: true
    },
    {
      type: 'Input',
      label: 'job_position',
      class: 'col-md-3 input-form',
      placeHolder: 'job_position',
      name: 'Position',
      id: 'Position',
      style: {},
      required: false
    },
    {
      type: 'Input',
      label: 'phone',
      class: 'col-md-3 input-form',
      placeHolder: 'phone',
      name: 'Telephone',
      id: 'Telephone',
      style: {},
      required: false
    },
    {
      type: 'Switch',
      label: 'active_alerts',
      class: 'col-md-3 input-form',
      placeHolder: '',
      name: 'ActiveAlerts',
      id: 'ActiveAlerts',
      style: {},
      required: false
    },
    // {
    //   type: 'Input',
    //   label: 'Cambiar contraseña',
    //   class: 'col-md-3 input-form',
    //   placeHolder: '',
    //   name: 'Password',
    //   id: 'Password',
    //   datatype: 'Password',
    //   style: {},
    //   required: false
    // },

    // {
    //   type: 'Input',
    //   label: 'Confirmar contraseña',
    //   class: 'col-md-3 input-form',
    //   placeHolder: '',
    //   name: 'ConfirmPassword',
    //   id: 'ConfirmPassword',
    //   datatype: 'Password',
    //   style: {},
    //   required: false
    // },
  ],
  previewForm: [
    {
      type: 'label',
      label: 'name',
      class: 'col-md-3 input-form',
      placeHolder: 'name',
      name: 'Name',
      id: 'Name',
      style: {},
      required: true
    },
    {
      type: 'label',
      label: 'last_name',
      placeHolder: 'last_name',
      name: 'Lastname',
      class: 'col-md-3 input-form',
      id: 'LastName',
      style: {},
      required: true
    },
    {
      type: 'label',
      label: 'job_position',
      placeHolder: 'job_position',
      name: 'Position',
      class: 'col-md-3 input-form',
      id: 'Position',
      style: {},
      required: false
    },
    {
      type: 'label',
      label: 'email',
      class: 'col-md-3 input-form',
      placeHolder: 'email',
      name: 'Email',
      id: 'Email',
      style: {},
      required: true
    },

    {
      type: 'select',
      options: 'RoleId',
      label: 'job_role',
      name: 'RoleId',

      class: 'col-md-3 input-form',
      id: 'RoleId',
      selectCatalogName: "Roles",
      style: {},
      required: true
    },
    {
      type: 'label',
      label: 'phone',
      class: 'col-md-3 input-form',
      placeHolder: 'phone',
      name: 'Telephone',
      id: 'Telephone',
      style: {},
      required: false
    },
    {
      type: 'label',
      label: 'active_alerts',
      class: 'col-md-3 input-form',
      placeHolder: 'phone',
      name: 'ActiveAlerts',
      id: 'ActiveAlerts',
      style: {},
      required: false
    },
    {
      type: 'password',
      label: 'Password *',
      class: 'col-md-3 input-form',
      placeHolder: '',
      name: 'Password',
      id: 'Password',
      datatype: 'Password',
      style: {},
      required: true
    }

    // {
    //   type: 'Input',
    //   label: 'Confirm Password',
    //   class: 'col-md-4 input-form',
    //   placeHolder: '',
    //   name: 'ConfirmPassword',
    //   id: 'ConfirmPassword',
    //   datatype: 'Password',
    //   style: {},
    //   required: true
    // }
  ]
}
export default adminForm